export default __webpack_public_path__ + "static/media/Frame_198.88213bee.jpg";